<template>
 <Dialog :visible="showDialog" modal :header="$t('DevTipLibraryOverlayComponent.yourTips', {text: featureNameDevTip})"
    :style="{ width: '50rem' }" class="mx-4">
      <div>
        <div v-if="!loading">
          <dev-tip-item-component v-for="item in getDevTippOverview"
                                  :key="item.tip_id || item._id || item"
                                  :tip="item"
                                  :show-text="true"
                                  />
          <p v-if="!getDevTippOverview || getDevTippOverview.length === 0">
            {{ $t('DevTipLibraryOverlayComponent.noTips', {text: featureNameDevTip}) }}
          </p>
        </div>
        <div v-else style="display: flex; justify-content: center">
          <img class="w-32 h-32" src="@/assets/loadingSpinner.svg" alt="txt" />
        </div>
      </div>
  </Dialog>
</template>

<script>
import DevTipItemComponent from '@/components/Home/Shared/DevTip/DevTipItemComponent.vue';
import { Dialog } from 'primevue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'DevTipLibraryOverlayComponent',
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  components: { DevTipItemComponent, Dialog },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    getDevTippOverview() {
      return this.$store.getters.getDevTippOverview;
    },
    featureNameDevTip() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'developmentTip',
        this.$t('FallbackTexts.developmentTip'),
        this.$i18n?.locale,
      );
    },
  },
  watch: {
    showDialog: {
      async handler(visible) {
        if (visible) {
          this.loading = true;
          await this.$store.dispatch('getDevTippOverview');
          this.loading = false;
        }
      },
    },
  },
  mounted() {
    this.loading = false;
  },
};
</script>
